// the review entry API exposes the AI third party matching result in `processingDecision`;
// the Billy contact id of the candidate marked as "selected" is the contact to prefill
export const getReviewEntryContactId = (processingDecision?: Record<string, unknown> | null): string | null => {
  const thirdParty = processingDecision?.thirdParty

  if (!thirdParty || typeof thirdParty !== 'object' || Array.isArray(thirdParty)) {
    return null
  }

  const candidates = (thirdParty as Record<string, unknown>).candidates

  if (!Array.isArray(candidates)) {
    return null
  }

  for (const candidate of candidates) {
    if (!candidate || typeof candidate !== 'object') {
      continue
    }

    const { billyContactId, status } = candidate as Record<string, unknown>

    if (status === 'selected') {
      return typeof billyContactId === 'string' && billyContactId.trim() !== '' ? billyContactId : null
    }
  }

  return null
}
